import { render, staticRenderFns } from "./familyLibrary.vue?vue&type=template&id=ed7a5cdc&scoped=true"
import script from "./familyLibrary.vue?vue&type=script&lang=js"
export * from "./familyLibrary.vue?vue&type=script&lang=js"
import style0 from "./familyLibrary.vue?vue&type=style&index=0&id=ed7a5cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7a5cdc",
  null
  
)

export default component.exports